import { memo } from 'react';

import { saveWorkingProjectByFields } from '@/store/slices/project';
import Text from '@ui/text/text/text';
import Switch from '@ui/switch/switch';
import Container from '@ui/container/container';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import { Registration } from '@/types/registration.types';

const SignInOptionDisplayPosition = memo(({ registrationSettings }: { registrationSettings?: Registration }) => {
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);
  const dispatch = useAppDispatch();

  const displayBeforeGeneralInfoQuestions = registrationSettings?.singleSignOn?.displayTop;

  const handleToggleDisplayBeforeGeneralInfoQuestions = (value: boolean, on: boolean) => {
    if (!registrationSettings) return;
    dispatch(
      saveWorkingProjectByFields({
        registration_settings: {
          ...registrationSettings,
          singleSignOn: {
            ...(registrationSettings?.singleSignOn ?? { isOn: false, displayTop: true }),
            displayTop: on,
          },
        },
      })
    );
  };

  return (
    <Container
      design="GlobalCont2"
      className="flex ai-center gap-8"
      padding="6px 6px 6px 10px"
      width="235px"
      height="32px"
      borderRadius="8px"
    >
      <Text className="C2" design="GlobalIcoText2" whiteSpace="nowrap">
        Display before general questions
      </Text>
      <Switch
        value={!!displayBeforeGeneralInfoQuestions}
        disabled={savingWorkingProject}
        on={!!displayBeforeGeneralInfoQuestions}
        onClick={handleToggleDisplayBeforeGeneralInfoQuestions}
      />
    </Container>
  );
});

SignInOptionDisplayPosition.displayName = 'SignInOptionDisplayPosition';

export default SignInOptionDisplayPosition;
